export default {
     getQueryString(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return decodeURIComponent(r[2]);
        }
        return null;
     },

     getImageUrl(name){
        return "http://api.fzsyjxh.com/api/v1/getImage?name="+name
      //   return "http://localhost:8081/api/v1/getImage?name="+name
     }
   
}